/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkLocation } from '../models/work-location';

@Injectable({ providedIn: 'root' })
export class WorkLocationsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `locationsV1ControllerSearchByKeyword()` */
  static readonly LocationsV1ControllerSearchByKeywordPath = '/v1/locations/search/{keyword}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `locationsV1ControllerSearchByKeyword()` instead.
   *
   * This method doesn't expect any request body.
   */
  locationsV1ControllerSearchByKeyword$Response(
    params: {
      keyword: string;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkLocation>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkLocationsService.LocationsV1ControllerSearchByKeywordPath, 'get');
    if (params) {
      rb.path('keyword', params.keyword, {});
      rb.header('x-api-key', params['x-api-key'], {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkLocation>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `locationsV1ControllerSearchByKeyword$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  locationsV1ControllerSearchByKeyword(
    params: {
      keyword: string;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkLocation>> {
    return this.locationsV1ControllerSearchByKeyword$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkLocation>>): Array<WorkLocation> => r.body)
    );
  }

}
